import { useState, useEffect } from "react";
import { useAppServices } from "../../../hook/services";
import DataTable from "./components/DataTable";

const AppRequests = () => {
  const AppService = useAppServices();
  const [processing, setProcessing] = useState(true);
  const [apps, setApps] = useState([]);
  const getData = async () => {
    const { response } = await AppService.provider_requests.get();
    if (response) {
      setApps(response.data);
    } else {
      setApps([]);
    }
    setProcessing(false);
  };
  useEffect(() => {
    getData();
  }, []);
  const columns = [
    {
      label: "Provider name",
      accessor: "providerName",
      sortable: true,
      renderCell: (row) => (
        <div className="d-flex align-items-center">
          <div className="fw-semibold text-dark">
            {row.providerName || (
              <span className="text-muted">Not specified</span>
            )}
          </div>
        </div>
      ),
    },
    {
      label: "Loom Video",
      accessor: "loomVideo",
      sortable: true,
      renderCell: (row) => (
        <div className="d-flex align-items-center">
          <div className="fw-semibold text-dark">
            {row.loomVideo || <span className="text-muted">Not specified</span>}
          </div>
        </div>
      ),
    },
    {
      label: "companyId",
      accessor: "companyId",
      sortable: true,
      renderCell: (row) => (
        <span className="badge bg-light text-dark border px-3 py-2 rounded-pill">
          {row.companyId || "-"}
        </span>
      ),
    },
  ];

  if (processing) {
    return (
      <div className="min-vh-100" style={{ backgroundColor: "#F5F6FA" }}>
        <div className="container-fluid p-4">
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ minHeight: "400px" }}
          >
            <div className="text-center">
              <div
                className="spinner-border text-primary mb-3"
                role="status"
                style={{ width: "3rem", height: "3rem" }}
              >
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="text-muted">Loading Requests...</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-vh-100" style={{ backgroundColor: "#F5F6FA" }}>
      <div className="container-fluid p-4">
        {/* Header Card */}
        <div
          className="card border-0 shadow-sm mb-4"
          style={{ backgroundColor: "white" }}
        >
          <div className="card-body py-4">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h4 className="mb-1 fw-bold text-dark">App Requests</h4>
                <p className="text-muted mb-0 small">Manage your Requests</p>
              </div>
            </div>
          </div>
        </div>

        <DataTable columns={columns} data={apps} entriesPerPage={10} />
      </div>
    </div>
  );
};

export default AppRequests;
